<!-- @format -->

<script setup>
defineEmits(['onCancel'])
const vDensity = {
  mounted(el, binding, vnode, prevVnode) {
    // console.log('density:',el)
    document.documentElement.style.fontSize = document.documentElement.clientWidth / 375 + 'px'
  },
}
</script>
<template>
  <div class="dialog_window" @click.stop.prevent="$emit('onCancel')" @touchmove.stop.prevent="" v-density>
    <slot></slot>
  </div>
</template>
<style scoped>
.dialog_window {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: #00000099;
}
</style>
